(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["clothe-stationery-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
const toggle=event.target.closest('[data-stationery-toggle]');if(toggle){event.preventDefault();const list=toggle.nextElementSibling;list.hidden=!list.hidden;toggle.setAttribute('aria-expanded',String(!list.hidden));return;}
const link=event.target.closest('.clothe-stationery-filters a');if(!link)return;
const destination=new URL(link.href),parameters=new URLSearchParams(window.location.search);parameters.delete('page');destination.search=parameters.toString();link.href=destination.toString();
});
document.addEventListener('keydown',event=>{if(event.key===' '&&event.target.matches('[data-stationery-toggle]')){event.preventDefault();event.target.click();}});
  } catch(e) { console.error(e); }
})();

})();
